import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';

import { UserAccessEndpoint } from './userAccessEndpoint.service';
import { AccessDto } from '../models/access.model';
import { DepartmentDto } from '../models/Department.model';
import { AgencyDto } from '../models/Agency.model';
import { RoleVldDto } from '../models/RoleVld.model';
import { UserProfileDto } from '../models/UserProfile.model';
import { BusinessRuleMessage } from '../models/BusinessRuleMessage.model';
import { UserProfileTypeDto } from '../models/UserProfileTypeListItem.model';

@Injectable()

export class UserAccessService {
  constructor(private router: Router, private userAccessEndpoint: UserAccessEndpoint) {
  }

  getDepartments(userProfileId?: string) {
    return this.userAccessEndpoint.getDepartments<DepartmentDto[]>(userProfileId);
  }

  getAgencies(departmentId?: string, userProfileId?: string) {
    return this.userAccessEndpoint.getAgencies<AgencyDto[]>(departmentId, userProfileId);
  }

  getUserAccesses(departmentId?: string, accessId?: string, userProfileId?: string) {
    return this.userAccessEndpoint.getUserAccesses<AccessDto[]>(departmentId, accessId, userProfileId);
  }

  getUserAccessesByApp(applicationVldID: number, departmentId?: string, accessId?: string, userProfileId?: string) {
    return this.userAccessEndpoint.getUserAccessesByApp<AccessDto[]>(applicationVldID, departmentId, accessId, userProfileId);
  }

  getUserAccess(accessId?: string, userProfileId?: string) {
    return this.userAccessEndpoint.getUserAccess<AccessDto>(accessId, userProfileId);
  }

  getRoles(userProfileId?: string) {
    return this.userAccessEndpoint.getRoles<RoleVldDto[]>(userProfileId);
  }

  getRolesByApp(applicationVldID: number,userProfileId?: string) {
    return this.userAccessEndpoint.getRolesByApp<RoleVldDto[]>(applicationVldID, userProfileId);
  }


  getVisibleUserProfiles(userProfileId?: string) {
    return this.userAccessEndpoint.getVisibleUserProfiles<UserProfileDto[]>(userProfileId);
  }
  
  createNewAccessItem(userProfileId?: string) {
    return this.userAccessEndpoint.createNewAccessItem<AccessDto>(userProfileId);
  }

  createNewUserProfile() {
    return this.userAccessEndpoint.createNewUserProfile<UserProfileDto>();
  }

  deleteUserAccess(accessId?: string, userProfileId?: string) {
    return this.userAccessEndpoint.deleteUserAccess<BusinessRuleMessage[]>(accessId, userProfileId);
  }

  submitUserAccess(userAccess: AccessDto, userProfileId?: string) {
    return this.userAccessEndpoint.submitUserAccess<BusinessRuleMessage[]>(userAccess, userProfileId);
  }

  deactivateUserAccess(userAccess: AccessDto, userProfileId?: string) {
    return this.userAccessEndpoint.deactivateUserAccess<BusinessRuleMessage[]>(userAccess, userProfileId);
  }

  activateUserAccess(userAccess: AccessDto, userProfileId?: string) {
    return this.userAccessEndpoint.activateUserAccess<BusinessRuleMessage[]>(userAccess, userProfileId);
  }


  getUserProfileTypes() {
    let item1 = new UserProfileTypeDto();
    item1.userProfileTypeId = 1;
    item1.userProfileTypeName = "Department User";

    let item2 = new UserProfileTypeDto();
    item2.userProfileTypeId = 2;
    item2.userProfileTypeName = "Agency User";

    let item3 = new UserProfileTypeDto();
    item3.userProfileTypeId = 3;
    item3.userProfileTypeName = "External Department User";

    let userProfileTypes: UserProfileTypeDto[] = [item1, item2, item3];

    return userProfileTypes;
  }
}
